import React from 'react';
import styles from './index.module.scss';

export interface CaseCardProps {
  title: string;
  description: string;
  image: string;
}

export default function CaseCard({ title, description, image }: CaseCardProps) {
  return (
    <article className={styles.card}>
      <img src={image} alt={title} loading="lazy" />
      <div className={styles.overlay}>
        <h3 className={styles.title}>{title}</h3>
        <p className={styles.desc}>{description}</p>
      </div>
      <div className={styles.hoverPanel}>
        <h3 className={styles.hoverTitle}>{title}</h3>
        <p className={styles.hoverDesc}>{description}</p>
      </div>
    </article>
  );
}
